import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ExpandIcon from '../../../components/common/ExpandIcon';
import { collapse, expand } from '../../../utils/transition';
import { Slip } from '../reducer';
import { getSavedSlipWithReturns } from '../selectors';
import SavedSlipDetailsConnect from './SavedSlipDetails';

export class SavedSlip extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.setCardMinHeight = this.setCardMinHeight.bind(this);
    this.contentNode = null;
    this.cardNode = null;
    this.summaryNode = null;
    this.state = {
      expanded: false
    };
  }

  componentDidMount() {
    this.setCardMinHeight();
  }

  componentDidUpdate() {
    this.setCardMinHeight();
  }

  setCardMinHeight() {
    if (!this.summaryNode) {
      return;
    }
    const summaryHeight = this.summaryNode.getBoundingClientRect().height;
    this.cardNode.style.minHeight = `${summaryHeight}px`;
  }

  toggle() {
    const { expanded } = this.state;

    this.setState({ expanded: !expanded });
    if (expanded) {
      collapse(this, 'saved-slip__details--expanded');
    } else {
      expand(this, 'saved-slip__details--expanded');
    }
  }

  render() {
    const { slip } = this.props;
    const { expanded } = this.state;

    const detailsClass = classnames('saved-slip__details', {
      'saved-slip__details--expanded': expanded
    });
    const summaryClass = classnames('saved-slip__summary', {
      'saved-slip__summary--hidden': expanded
    });

    return (
      <div className="saved-slips__list-item saved-slip" key={slip.id}>
        <div
          className="saved-slip__header"
          onClick={this.toggle}
        >
          <div>{slip.slipName}</div>
          <ExpandIcon expanded={expanded} />
        </div>
        <div
          className="saved-slip__card"
          ref={ref => {
            this.cardNode = ref;
          }}
        >
          <div
            className={summaryClass}
            ref={ref => {
              this.summaryNode = ref;
            }}
          >
            <div className="saved-slip__property">
              <div>Selections:</div>
              <div className="saved-slip__property-value">
                {slip.legs.size}
              </div>
            </div>
            <div className="saved-slip__property">
              <div>Stake:</div>
              <div className="saved-slip__property-value">
                £{Number(slip.slipStake).toFixed(2)}
              </div>
            </div>
            <div className="saved-slip__property">
              <div>Returns:</div>
              <div className="saved-slip__property-value">
                £{Number(slip.potentialReturns).toFixed(2)}
              </div>
            </div>
            <div className="saved-slip__property">
              <div>Created:</div>
              <div className="saved-slip__property-value">
                {slip.slipCreatedDateTime}
              </div>
            </div>
          </div>
          <div
            className={detailsClass}
            ref={ref => {
              this.contentNode = ref;
            }}
          >
            <SavedSlipDetailsConnect id={slip.id} />
          </div>
        </div>
      </div>
    );
  }
}

SavedSlip.propTypes = {
  slip: PropTypes.instanceOf(Slip).isRequired
};

const mapStateToProps = (state, props) => ({
  slip: getSavedSlipWithReturns(state, props)
});

export default connect(mapStateToProps)(SavedSlip);
